import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import MinisterImg from '../StaticImages/Minister_Santina_professional.png';
import { Section } from '../Common/PageLayout';
import { tokens } from '../../theme';

const useStyles = makeStyles((theme) => ({
    panel: {
        border: `1px solid ${tokens.border}`,
        borderRadius: tokens.radius,
        overflow: 'hidden',
        backgroundColor: tokens.white,
    },
    imageWrap: {
        height: '100%',
        minHeight: 360,
        backgroundColor: tokens.blue50,
        [theme.breakpoints.down('sm')]: { minHeight: 300 },
    },
    image: {
        display: 'block',
        width: '100%',
        height: '100%',
        minHeight: 360,
        objectFit: 'cover',
        objectPosition: 'center top',
        [theme.breakpoints.down('sm')]: { minHeight: 300 },
    },
    body: {
        padding: theme.spacing(6),
        [theme.breakpoints.down('sm')]: { padding: theme.spacing(3.5) },
    },
    overline: {
        display: 'block',
        color: tokens.blue600,
        fontSize: '0.75rem',
        fontWeight: 700,
        letterSpacing: '0.12em',
        textTransform: 'uppercase',
        marginBottom: theme.spacing(2),
    },
    title: {
        marginBottom: theme.spacing(2.5),
        color: tokens.ink,
    },
    paragraph: {
        color: tokens.inkSoft,
        fontSize: '1rem',
        lineHeight: 1.75,
        margin: `0 0 ${theme.spacing(2)}px`,
    },
    signature: {
        marginTop: theme.spacing(3),
        paddingTop: theme.spacing(3),
        borderTop: `1px solid ${tokens.border}`,
    },
    name: {
        fontFamily: tokens.headingFont,
        fontWeight: 600,
        fontSize: '1.0625rem',
        color: tokens.ink,
        margin: 0,
    },
    role: {
        color: tokens.muted,
        fontSize: '0.9375rem',
        margin: '2px 0 0',
    },
    actions: {
        marginTop: theme.spacing(3),
        display: 'flex',
        gap: theme.spacing(2),
        flexWrap: 'wrap',
    },
}));

/** Introduction to the Office of the Minister and the Ministry's mandate. */
export default function MinisterMessage() {
    const classes = useStyles();

    return (
        <Section tone="default">
            <div className={classes.panel}>
                <Grid container>
                    <Grid item xs={12} md={4} className={classes.imageWrap}>
                        <img
                            src={MinisterImg}
                            alt="Santina J R F. Viegas Cardoso, Minister of Finance"
                            className={classes.image}
                        />
                    </Grid>
                    <Grid item xs={12} md={8}>
                        <div className={classes.body}>
                            <span className={classes.overline}>Office of the Minister</span>

                            <Typography variant="h3" component="h2" className={classes.title}>
                                Sound public finances for a stronger Timor-Leste
                            </Typography>

                            <p className={classes.paragraph}>
                                The Ministry of Finance is responsible for the design and execution
                                of fiscal policy: preparing the State Budget, managing the treasury
                                and public debt, overseeing revenue collection, and accounting for
                                every dollar of public expenditure.
                            </p>
                            <p className={classes.paragraph}>
                                Under the leadership of the Minister, the Ministry is advancing
                                public financial management reform, strengthening transparency in
                                budget execution and modernising the systems that citizens,
                                businesses and development partners rely on.
                            </p>

                            <div className={classes.signature}>
                                <p className={classes.name}>Santina J R F. Viegas Cardoso</p>
                                <p className={classes.role}>
                                    Minister of Finance, Democratic Republic of Timor-Leste
                                </p>
                            </div>

                            <div className={classes.actions}>
                                <Button
                                    component={RouterLink}
                                    to="/pagedetails/minister-of-finance"
                                    variant="contained"
                                    color="primary"
                                    endIcon={<ArrowForwardIcon />}
                                >
                                    About the Minister
                                </Button>
                                <Button component={RouterLink} to="/profile" variant="outlined">
                                    About the Ministry
                                </Button>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </div>
        </Section>
    );
}
